import React, { useEffect, useState } from "react";
import AppContainer from "../Components/Structure/AppContainer";
import functions from "../util/functions";
import { RenderSecure } from "../util/script/RenderSecure";
import toast, { Toaster } from "react-hot-toast";
import Card from "../Components/Common/Card";
import UserWelcomeCard from "../Components/dashboard/UserWelcomeCard";
import CardsComponent from "../Components/dashboard/CardsComponent";
import DepartmentsListCard from "../Components/Departments/DepartmentsListCard";
import RequisitionsTable from "../Components/dashboard/RequisitionsTable";
import DashboardInvoicesMini from "../Components/SupplierIvoices/DashboardInvoicesMini";
function Dashboard() {
  const [showWelcomeCard, setShowWelcomeCard] = useState(true);

  return (
    <div>
      <AppContainer title="Dashboard/poultry">
        <div className="row row-sm">
          <div className="col-sm-12 col-lg-8 col-xl-8">
            {/*Row*/}
            {showWelcomeCard && (
              <div className="row row-sm ">
                <UserWelcomeCard />
              </div>
            )}
            {/*Row */}
            {/*Row*/}
            <div>
              <CardsComponent />
            </div>
            {/*End row*/}
            {/*row*/}
            <div className="row row-sm">
              {/* col end */}
              <div className="col-lg-15">
                <div className="card custom-card mg-b-20">
                  <div className="card-body">
                    <div className="card-header border-bottom-0 pt-0 pe-0 d-flex">
                      <div>
                        <label className="main-content-label mb-2">
                          New Requistions
                        </label>
                        <span className="d-block tx-12 mb-3 text-muted">
                          Recent Requistions posted
                        </span>
                      </div>
                      <div className="ms-auto">
                        <a
                          href="javascript:void(0)"
                          className="option-dots"
                          data-bs-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          <i className="fe fe-more-vertical" />
                        </a>
                      </div>
                    </div>
                    <div className="table-responsive tasks">
                      <RequisitionsTable />
                    </div>
                  </div>
                </div>
              </div>
              {/* col end */}
            </div>
            {/* Row end */}
          </div>
          {/* col end */}
          <div className="col-sm-12 col-lg-4 col-xl-4 ">
            <div className="">
              <DepartmentsListCard />
            </div>
            <div className="card custom-card">
              <DashboardInvoicesMini />
            </div>
          </div>
          {/* col end */}
        </div>
      </AppContainer>
    </div>
  );
}
export default Dashboard;
